import {MapEnum} from "../../enums/MapEnum";
import {IMapEnumElement} from "../../enums/interface";

class LogoUsageTypeMapEnum extends MapEnum<IMapEnumElement>  {
    public static OWNER_ONLY: IMapEnumElement = {id: 1, name: "Owner Only"};
    public static PARTNER_ONLY: IMapEnumElement = {id: 2, name: "Partner Only"};
    public static BOTH: IMapEnumElement = {id: 3, name: "Both"};

    static {
        this.createElement();
    }
    static Instance(): LogoUsageTypeMapEnum {
        return super.Instance();
    }
    static InstanceWithValue(value:number): LogoUsageTypeMapEnum {
        return super.InstanceWithValue(value);
    }
    static InstanceWithName(name:string): LogoUsageTypeMapEnum {
        return super.InstanceWithName(name);
    }
    static InstanceWithFieldName(fieldName:string): LogoUsageTypeMapEnum {
        return super.InstanceWithFieldName(fieldName);
    }

}
export  default LogoUsageTypeMapEnum;